export default __webpack_public_path__ + "static/media/ecosystem-diagram-2.2c869c79.png";